module.exports = __webpack_public_path__ + "img/GHS05.abaf4418.gif";